import wx from 'weixin-js-sdk'
import { Axios } from "../assets/js/ls_com_axios.js"
const getsignatureInfo = ({
    url, title, desc, imgUrl
}) => {
    Axios("post", "/fodder/order/signature?url=" + url, {}, false, function (res) {
        const config = res.data.data;
        wx.config({
            // debug: true,
            appId: "wx2887ecd4dd18a4f1",  // appID 公众号的唯一标识
            timestamp: config.timestamp, // 生成签名的时间戳
            nonceStr: config.noncestr, //  生成签名的随机串
            signature: config.signature, // 生成的签名
            jsApiList: [
                'updateAppMessageShareData', // 分享到朋友
                'updateTimelineShareData', // 分享到朋友圈
            ]
        });
        wx.ready(() => {
            var shareData = {
                title: title,
                desc: desc,
                link: location.href.split('#')[0], // 分享后的地址
                imgUrl: imgUrl,
                success: () => {
                    console.log("分享成功")
                },
                cancel: (e) => {
                    console.log("分享失败", e)
                }
            };
            //点击要去分享
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(shareData);
        });
    })
}
export default getsignatureInfo